module.exports = __webpack_public_path__ + "img/blank-map.90cb1431.png";